import { useDesignerStore } from "../store";

class PropertyManager {

  private getSelectedObject() {
    return useDesignerStore.getState().selectedObject;
  }

  private refresh(object: any) {
    object.canvas?.renderAll();

    // Force React to refresh
    useDesignerStore.getState().setSelectedObject(object);
  }

  setFontSize(size: number) {

    const object = this.getSelectedObject();

    if (!object || object.type !== "i-text") return;

    object.set({
      fontSize: size,
    });

    this.refresh(object);
  }

  setFontFamily(font: string) {

    const object = this.getSelectedObject();

    if (!object || object.type !== "i-text") return;

    object.set({
      fontFamily: font,
    });

    this.refresh(object);
  }

  setFillColor(color: string) {

    const object = this.getSelectedObject();

    if (!object || object.type !== "i-text") return;

    object.set({
      fill: color,
    });

    this.refresh(object);
  }

  toggleBold() {

    const object = this.getSelectedObject();

    if (!object || object.type !== "i-text") return;

    object.set({
      fontWeight:
        object.fontWeight === "bold"
          ? "normal"
          : "bold",
    });

    this.refresh(object);
  }

  toggleItalic() {

    const object = this.getSelectedObject();

    if (!object || object.type !== "i-text") return;

    object.set({
      fontStyle:
        object.fontStyle === "italic"
          ? "normal"
          : "italic",
    });

    this.refresh(object);
  }

}

export const propertyManager = new PropertyManager();